import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import {omit} from "lodash"

import id from "@irati/utils/id"
import {EMOJI} from "@irati/ui/src/Reactions/constants"
import {TextArea} from "@irati/ui/src/FormItem"

const StyledTextArea = styled(TextArea)`
  textarea {
    min-height: 80px;
    resize: vertical;
  }
`

class Recognition extends Component {
  static propTypes = {
    autoFocus: PropTypes.bool,
    hideLabel: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    onFocus: PropTypes.func
  }

  static defaultProps = {
    autoFocus: true,
    hideLabel: true,
    id: "recognition",
    label: "Recognition",
    onFocus: () => {}
  }

  handleFocus = (event) => {
    this.props.onFocus(event)
  }

  render() {
    const fieldProps = omit(this.props, ["onFocus"])

    return (
      <StyledTextArea
        {...fieldProps}
        onFocus={this.handleFocus}
        name={id("", this.props)}
        id={id("", this.props)}
        textReplaceTypes={[EMOJI]} />
    )
  }
}

export default Recognition
